import { EmployeeMatchingType, MatchedEmployee } from '@/modules/employer/components/Lockbox/lockbox.types';

export const addInvestmentsWarning = (employee: MatchedEmployee, enabled?: boolean) => {
  if (!enabled || !employee?.investmentsBalance || employee?.investmentsBalance <= 0) {
    return employee;
  }

  return {
    ...employee,
    labelTypes: [...(employee?.labelTypes || []), EmployeeMatchingType.INVESTMENTS_TO_BE_LIQUIDATED],
  };
};
